import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const ModalContent = styled.div`
    width: 100%;
    max-width: 100vw;
    max-height: 95vh;
    padding: 0 4rem 4rem 4rem;
    align-items: center;
    ${device.md} {
        max-width: 80vw;
        max-height: 80vh;
        padding: 0 1rem 0 1rem;
    }
    margin: auto;
    background-color: ${colourScheme.primaryDark};
    overflow-y: auto;
    display: flex;
    flex-direction: column;
`;

export const ButtonContainer = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${colourScheme.primaryDark};
    padding: 1rem;
    display: flex;
    justify-content: center;
    gap: 1rem;
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
    z-index: 9999;
`;
